import { useState } from "react";

import { useAdminApiQueryWithParams } from "../../../hooks";
import {
  ICustomersSummary,
  ICustomersOverview,
} from "../../../interfaces-and-types";
import { TSummaryPeriod } from "../../../constants";
import { ISummarySectionProps, ISummarySectionViewProps } from "../Home";

import { View } from "./View";

export interface ICustomersSummaryViewProps extends ISummarySectionViewProps<ICustomersOverview> {}

export const CustomersSummary = ({
  activeCurrency,
  customChartPeriod,
}: ISummarySectionProps) => {
  const [summaryPeriod, setSummaryPeriod] = useState<TSummaryPeriod>("today");

  const {
    isLoading: isLoadingCustomersSummary,
    // isSuccess: isSuccessCustomersSummary,
    // isError: isErrorCustomersSummary,
    data: customersSummary,
    refetch: refetchSummary,
  } = useAdminApiQueryWithParams<{ currency: string }, ICustomersSummary>(
    [
      "getCustomersSummary",
      {
        currency: activeCurrency!,
      },
    ],
    {
      enabled: !!activeCurrency,
    },
  );

  const {
    isLoading: isLoadingCustomersOverviewByPeriod,
    // isSuccess: isSuccessCustomersOverviewByPeriod,
    // isError: isErrorCustomersOverviewByPeriod,
    data: customersOverviewByPeriod,
    refetch: refetchOverviewByPeriod,
  } = useAdminApiQueryWithParams<
    { currency: string; startDate: string; endDate: string },
    ICustomersOverview
  >(
    [
      "getCustomersOverviewByPeriod",
      {
        currency: activeCurrency!,
        startDate: customChartPeriod.startDate,
        endDate: customChartPeriod.endDate,
      },
    ],
    {
      enabled:
        !!activeCurrency &&
        !!customChartPeriod.startDate &&
        !!customChartPeriod.endDate &&
        summaryPeriod === "custom",
    },
  );

  const refreshData =
    summaryPeriod === "custom" ? refetchOverviewByPeriod : refetchSummary;

  const summaryToDisplay =
    summaryPeriod === "today"
      ? customersSummary?.today
      : summaryPeriod === "past week"
        ? customersSummary?.past_week
        : summaryPeriod === "past month"
          ? customersSummary?.past_month
          : summaryPeriod === "custom"
            ? customersOverviewByPeriod
            : customersSummary?.all_time;

  const isLoadingSummary =
    summaryPeriod === "custom"
      ? isLoadingCustomersOverviewByPeriod
      : isLoadingCustomersSummary;

  return (
    <View
      activeCurrency={activeCurrency}
      isLoadingSummary={isLoadingSummary}
      summaryToDisplay={summaryToDisplay || null}
      summaryPeriod={summaryPeriod}
      setSummaryPeriod={setSummaryPeriod}
      refreshData={refreshData}
    />
  );
};
